const versionsInfo = [
    //Add the new version with the corresponding details here
    //following the object shape from below
    {
        typeVersioning: 'Major',
        version: '1.0.0 Beta',
        description: 'This is the initial version of the platform.',
        features: ['Feature 1', 'Feature 2', 'Feature 3'],
        bugsFixed: ['Bug 1', 'Bug 2', 'Bug 3'],
    },
];

export default versionsInfo;
